import { render, staticRenderFns } from "./role_management.vue?vue&type=template&id=42928bd2&scoped=true"
import script from "./role_management.vue?vue&type=script&lang=js"
export * from "./role_management.vue?vue&type=script&lang=js"
import style0 from "./role_management.vue?vue&type=style&index=0&id=42928bd2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42928bd2",
  null
  
)

export default component.exports